import { createApi,fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {getPromotions} from "./api";
import {changeHeaders} from "../request";


export const promoApi = createApi({
    reducerPath: 'promo/api',
    baseQuery: fetchBaseQuery({
        baseUrl: "/api/v1/",
        prepareHeaders: (headers, { getState }) =>
            changeHeaders(headers, { getState }),
    }),
    endpoints: (build) => ({
        getPromotions: build.query({
            query: (page: string) => getPromotions(page),
        })
    })
})


export const {
    useLazyGetPromotionsQuery
} = promoApi;
